/**
 * VARIATION_HEADER.JSX - Variation Modal Header Component
 * 
 * SUMMARY:
 * Presentational component that displays the modal header for variations.
 * Determines the appropriate title based on the current action (new/edit/revise).
 * 
 * PROPS:
 * @param {boolean} editMode - Whether in edit mode
 * @param {string} action - Action type ('new', 'edit', 'revise')
 * @param {boolean} editOption - Whether editing existing option
 * 
 * @returns {JSX.Element} Modal header
 */

import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function VariationHeader({ editMode, action, editOption }) {
    /**
     * Get modal header text based on mode and action
     */
    const getModalHeader = () => {
        if (!editMode) return "Variation Details";
        if (action === "new") return "Create Variation";
        if (action === "revise") return "Revise Variation";
        if (editOption) return "Edit Variation";
        return "Create Variation";
    };

    return (
        <Modal.Header closeButton data-cy={'variation-modal-header'}>
            <Modal.Title>{getModalHeader()}</Modal.Title>
        </Modal.Header>
    );
}

